module.exports = flarum.core.compat['components/FieldSet'];